
export interface ITopPanelStoreValue {
  name: string;
  value: object;
}


export interface ITopPanelState {
  parametersValues: Array<ITopPanelStoreValue>;
  queryParameters: object;
}
export const initialTopPanelState:ITopPanelState = {
  parametersValues: [],
  queryParameters: undefined

};

